export default __webpack_public_path__ + "static/media/dono-example.505005c0.png";